import $ from "jquery";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";

const init = function() {
    $("[activate]").click(function() {
        setSiteIsActive($(this).attr("activate") === "true", $(this).attr("siteId"));
    });
};

function setSiteIsActive(manualSet, siteId) {
    const isActive = manualSet;
    $("#btnSetSiteActivations").attr("disabled", "disabled");
    return $.Deferred(function(def) {
        dataaccess.patch({ url: "/api/site/" + siteId + "/active/" + isActive }).done(function() {
            $("[activate=\"" + isActive + "\"]").addClass("hidden");
            $("[activate=\"" + !isActive + "\"]").removeClass("hidden");
            $("#activeLabel").text(isActive ? "Active" : "Deactivated");
            if (isActive) $("#activeCircleIndicator").removeClass("text-danger").addClass("text-success");
            else $("#activeCircleIndicator").removeClass("text-success").addClass("text-danger");
            services.notificationService.success("Successfully " +
                (isActive ? "Activated" : "Deactivated") +
                " Site.");
        }).always(function() {
            $("#btnSetSiteActivations").removeAttr("disabled");
            def.resolve();
            window.location.href = application.baseUrl + "/siteDetails/index/" + $("#hdnSiteId").val();
        });
    });
}
function enableActivation() {
    const canEnable = $("#hdnCanActivate").val() === "true";
    if (canEnable) $("#btnSetSiteActivations").removeAttr("disabled");
}
function disableActivation() {
    $("#btnSetSiteActivations").attr("disabled", "disabled");
}

export const siteActivate = {
    init: init,
    enableActivation: enableActivation,
    disableActivation: disableActivation,
    setSiteIsActive: setSiteIsActive
};